import { useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';

export const useOtherBrandsAvailableModalClosed = () =>
    useSelector((state: RootState) => state.otherBrandsAvailableModalClosed);
